import { PaginatedSearchRequest } from "../../../../_shared/models/paginated-search-request.model";
import { NoteType } from "../enums/note-type.enum";
import { PartRequestStatus } from "../enums/part-request-status.enum";
export { PartRequestActionState } from "../enums/part-request-action-state.enum";

export type PartRequestStatusVariant = 'pending' | 'approved' | 'rejected';

export type RequestStatusSummary = {
  text: string;
  variant: PartRequestStatusVariant;
  category: 'Draft' | 'Pending' | 'Approved' | 'Rejected' | 'Issued';
};

export interface PartsRequestFilterRequest extends PaginatedSearchRequest {
  accountIds: number[];
  dateFrom: string | null;
  dateTo: string | null;
  status: PartRequestStatus | null;
}

export type SortDirection = 'asc' | 'desc' | null;

export type PartsRequestSortColumn =
  | 'workOrderNumber'
  | 'asset'
  | 'requestedBy'
  | 'quantity'
  | 'date';

export interface PartRequest {
  workOrderId: number;
  workOrderNumber: string;
  asset: string;
  requestedBy: string;
  quantity: number;
  date: string;
  status: string;
  parts: PartRequestItem[];
}

export interface RejectWorkOrderPartsRequest {
  partRequestIds: number[];
  note: string | null;
}

export interface ApproveWorkOrderPartsRequest {
  partRequestIds: number[];
}

export interface ResetWorkOrderPartsRequest {
  partRequestIds: number[];
}

export interface PartNoteTarget {
  id: number;
  partNumber: string;
  category?: string;
}

export interface PartRequestItem extends PartNoteTarget {
  partId: number;
  partName: string;
  description: string;
  category: string;
  quantityAvailable: number;
  quantityRequested: number;
  status: PartRequestStatus;
  hasNotes: boolean;
}

export interface IssuePart {
  id: number;
  partNumber: string;
  description: string;
  category: string;
  onHand: number;
  quantityRequested: number;
}

export interface IssuePartsWorkOrderData {
  workOrderId: number;
  workOrderNumber: string;
  parts: IssuePart[];
}

export enum IssuePartsMode {
  Single = 'single',
  Bulk = 'bulk'
}

export interface IssuePartsWorkOrder {
  workOrderId: number;
  partRequestIds: number[];
}

export interface IssuePartsRequest {
  workOrders: IssuePartsWorkOrder[];
}

export interface PartRequestNote {
  content: string;
  createdBy: string;
  createdAt: string;
  noteTypeId: NoteType;
}

export interface AddPartRequestNoteRequest {
  content: string;
  noteTypeId: NoteType;
}